module.exports = __webpack_public_path__ + "280acecc3897c02609b5684befc702e0.png";